<template>
<div class="svg-container-outer">
    <div class="svg-container">
        <loading-charts v-if="loadingData" class="loading-charts"/>
        <div class="button-container">
            <input
                class="search-shipments"
                type="text"
                v-model="searchTerm"
                placeholder="Search shipments..."
            />
        </div>
        <div class="status-filter-container">
            <button
                class="status-filter-button"
                :class="{ active: shipmentStatusFilter === 'all' }"
                @click="shipmentStatusFilter = 'all'"
            >
                All
            </button>

            <button
                class="status-filter-button delivered"
                :class="{ active: shipmentStatusFilter === 'delivered' }"
                @click="shipmentStatusFilter = 'delivered'"
            >
                Delivered
            </button>

            <button
                class="status-filter-button in-transit"
                :class="{ active: shipmentStatusFilter === 'inTransit' }"
                @click="shipmentStatusFilter = 'inTransit'"
            >
                In Transit
            </button>
        </div>
        <div class="table-container-main">
            <div class="responsive-table">
                <div class="table-header" id="header">
                    <div class="col-1">Stop</div>
                    <div class="col-2">Arrival</div>
                    <div class="col-3">Address</div>
                    <div class="col-4">Shipment</div>
                </div>
                <loading-charts v-if="loadingTable" class="loading-charts"/>
                <div class="table-row-container">
                    <!-- <div class="table-row" v-for="(shipment, index) in tripShipments" :key="index"> -->
                    <div 
                        class="table-row"
                        :class="{ 'highlight-row': matchedStopIndexes.includes(index) }"
                        :ref="matchedStopIndexes.includes(index) ? 'matchedRow' : null"
                        v-for="(shipment, index) in filteredTripShipmentsByStatus"
                        :key="index"
                    >
                        <div class="col-1" v-if="shipment?.serviceStatus != 'Error'"><p class="shipmentid-text" id="shipmentid-text">{{shipment.stop}}</p></div>
                        <div class="col-1" v-else><p class="shipmentid-text" style="background-color: red; color: #fff;" id="shipmentid-text">{{shipment.stop}}</p></div>
                        <div class="col-2 col-data">{{ shipment?.arrival
                                        ? formatLocalTimeArrival(shipment.arrival)
                                        : "" }}</div>
                        <div class="col-3 col-data" v-if="shipment.address">{{shipment.address.address1}}, {{shipment.address.city}}, {{shipment.address.state}}, {{shipment.address.zipCode}}</div>
                        <!-- <div class="col-3 col-data"><p class="service-text">{{shipment.status}}</p></div> -->
                        <div class="col-4 col-data" v-if="shipment.shipments && shipment.shipments.length > 0">
                            <div v-for="(shipmentItem, item) in shipment.shipments" :key="item">
                                <div class="shipment-status-container">
                                    <p style="flex-wrap: nowrap;" class="shipmentid-text" @click="trackShipment(shipmentItem.shipmentID)">{{shipmentItem.shipmentID}}</p>
                                    <p class="activity-description">{{shipmentItem?.lastActivity?.description ?? ""}}</p>
                                    <p style="font-size: 12px;">{{ shipmentItem?.lastActivity?.activityTime
                                        ? formatLocalTime(shipmentItem.lastActivity.activityTime)
                                        : "" }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="filteredTripShipmentsByStatus.length == 0" class="table-row-container">
                    <div class="table-row">
                        <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                        <div class="col-2 col-data">No Shipments</div>
                        <div class="col-3 col-data"><p class="service-text"></p></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-container">
            <div class="print-selected close-label">
                <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
                <p class="print-selected-text download-csv" @click="createStopsPdf()">Download PDF</p>
            </div>
        </div>
    </div>
</div>

<shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :trackShipmentID="trackShipmentID" :cognitoUser="cognitoUser" :userData="userData"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import ShipmentInfo from './../ShipmentInfo.vue'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import AlertUser from '../../Popups/AlertUser.vue';
import jsonexport from 'jsonexport'
import { PDFDocument, StandardFonts } from 'pdf-lib'
import bwipjs from 'bwip-js';

export default {
    components:{
        ShipmentInfo,
        LoadingCharts,
        AlertUser
    },
    props: ['userData', 'cognitoUser', 'filterByTripSheetID'],
    data(){
        return{
            trackShipmentID: null,
            toggleTrackShipment: false,
            user: null,
            loadingData: false,
            loadingTable: false,
            isFiltered: false,
            filterField: '',
            filterValue: '',
            toggleAlertBox: '',
            alertMessage: '',
            tripShipments: [],
            searchTerm: '',
            shipmentStatusFilter: 'all'
        }
    },
    mounted(){
        if (this.filterByTripSheetID) {
            let event = {
                filterField: "tripSheetID",
                filterValue: this.filterByTripSheetID
            };

            this.runFilter(event);
        }
    },
    watch: {
        matchedStopIndexes(newVal) {
            if (newVal.length >= 1) {
                this.$nextTick(() => {
                    const firstMatchedEl = this.$refs.matchedRow?.[0];

                    if (firstMatchedEl && typeof firstMatchedEl.scrollIntoView === 'function') {
                        firstMatchedEl.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                });
            }
        }
    },
    computed: {
        matchedStopIndexes() {
            if (!this.searchTerm || this.searchTerm.length < 3) {
                return [];
            }

            const search = this.searchTerm.toLowerCase();

            return this.tripShipments
                .map((stop, index) => {
                    const searchableText = JSON.stringify(stop || {}).toLowerCase();

                    return searchableText.includes(search) ? index : null;
                })
                .filter(index => index !== null);
        },
        filteredTripShipmentsByStatus() {
            if (this.shipmentStatusFilter === 'all') {
                return this.tripShipments;
            }

            return this.tripShipments.filter(stop => {
                const shipments = Array.isArray(stop.shipments) ? stop.shipments : [];

                if (this.shipmentStatusFilter === 'delivered') {
                    return shipments.some(shipment =>
                        shipment?.lastActivity?.shippingEvent === 'delivered'
                    );
                }

                if (this.shipmentStatusFilter === 'inTransit') {
                    return shipments.some(shipment =>
                        shipment?.lastActivity?.shippingEvent !== 'delivered'
                    );
                }

                return true;
            });
        }
    },
    methods:{
        async makePdf417PngBytes(text) {
            const canvas = document.createElement('canvas');
            await bwipjs.toCanvas(canvas, {
                bcid: 'pdf417',
                text: String(text),
                scale: 2,
                height: 10,
                includetext: false,
                columns: 6,
            });

            const blob = await new Promise(res => canvas.toBlob(res, 'image/png'));
            const ab = await blob.arrayBuffer();
            return new Uint8Array(ab);
            },
        async createStopsPdf() {
            try {
                let stops = this.tripShipments;
                const sorted = [...stops].sort((a, b) => (a.stop ?? 0) - (b.stop ?? 0));
                const statusFiveStops = sorted.filter(s => String(s.status) > "0");

                const cleanPdfText = value => {
                    return String(value ?? "")
                        .replace(/[\u200B-\u200D\uFEFF]/g, "")
                        .replace(/[‘’]/g, "'")
                        .replace(/[“”]/g, '"')
                        .replace(/[–—]/g, "-");
                };

                const drawSafeText = (text, options) => {
                    const cleaned = cleanPdfText(text);

                    try {
                        page.drawText(cleaned, options);
                    } catch (err) {
                        console.error("Unable to draw PDF text:", {
                            text,
                            cleaned,
                            error: err
                        });

                        page.drawText("[Unsupported Text]", options);
                    }
                };

                const allShipments = sorted.flatMap(s =>
                    Array.isArray(s.shipments) ? s.shipments : []
                );

                const locationVisitCount = allShipments.filter(sh =>
                    Array.isArray(sh.additionalServices) &&
                    sh.additionalServices.includes("LOCVISIT")
                ).length;

                const customerPickupCount = allShipments.filter(sh =>
                    sh.isDelivery === false &&
                    !(
                        Array.isArray(sh.additionalServices) &&
                        sh.additionalServices.includes("LOCVISIT")
                    )
                ).length;

                const deliveryCount = allShipments.filter(sh =>
                    sh.isDelivery === true &&
                    !(
                        Array.isArray(sh.additionalServices) &&
                        sh.additionalServices.includes("LOCVISIT")
                    )
                ).length;

                const pdf = await PDFDocument.create();
                let page = pdf.addPage();
                const font = await pdf.embedFont(StandardFonts.Helvetica);
                const fontBold = await pdf.embedFont(StandardFonts.HelveticaBold);

                const margin = 50;
                const lineH = 16;
                let y = page.getHeight() - margin;

                const line = (text, { bold = false, size = 12 } = {}) => {
                    if (y < margin + lineH) {
                        page = pdf.addPage();
                        y = page.getHeight() - margin;
                    }

                    drawSafeText(text, {
                        x: margin,
                        y: y - lineH,
                        size,
                        font: bold ? fontBold : font
                    });

                    y -= lineH;
                };

                const toLocalTime = t => {
                    if (!t || typeof t !== "string" || !t.includes(":")) return "";

                    const [h, m] = t.split(":");
                    const d = new Date();

                    d.setHours(Number(h), Number(m), 0, 0);

                    return d.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit"
                    });
                };

                for (const s of sorted) {
                    if (s.waypoint == "*") {
                        const time = [s.startTime, s.endTime]
                            .filter(Boolean)
                            .map(toLocalTime)
                            .join(" – ");

                        const createdLocal = new Date(s.created).toLocaleString([], {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "numeric",
                            minute: "2-digit"
                        });

                        line("LREX " + createdLocal + " Route " + s.route + " ( " + time + " )", { bold: true, size: 12 });
                        line(`Location Visits: ${locationVisitCount}`, { bold: true, size: 10 });
                        line(`Customer Pickups: ${customerPickupCount}`, { bold: true, size: 10 });
                        line(`Deliveries: ${deliveryCount}`, { bold: true, size: 10 });
                        y -= 6;
                    }

                    if (s.waypoint === "*" && s.totalDistance && s.totalTime) {
                        const totalTime = Number(s.totalTime / 60).toFixed(2);
                        const totalDistance = Number(s.totalDistance).toFixed(2);

                        const timeText = `Total Time: ${totalTime} hours`;
                        const distText = `Total Miles: ${totalDistance}`;
                        const fontSize = 12;

                        const rightTextWidth = font.widthOfTextAtSize(distText, fontSize);

                        const leftX = margin;
                        const rightX = page.getWidth() - margin - rightTextWidth;

                        drawSafeText(timeText, { x: leftX, y: y - lineH, size: fontSize, font });
                        drawSafeText(distText, { x: rightX, y: y - lineH, size: fontSize, font });

                        y -= lineH + 6;
                    }

                    const width = page.getWidth();

                    page.drawLine({
                        start: { x: 50, y },
                        end: { x: width - 50, y },
                        thickness: 1,
                        dashPhase: 0,
                    });

                    const header = s.waypoint === "*" ? "" : Number.isFinite(s.stop) ? `Stop ${s.stop}` : "Stop";

                    const time = [s.windowStart, s.windowEnd]
                        .filter(Boolean)
                        .map(toLocalTime)
                        .join(" – ");

                    const arrivalTime = [s.arrival]
                        .filter(Boolean)
                        .map(toLocalTime);

                    if (s.stop !== null && s.stop !== undefined && !isNaN(Number(s.stop))) {
                        line(`${header} ${arrivalTime} ${time ? ` (${time})` : ""}`, {
                            bold: true,
                            size: 13
                        });
                    }

                    console.log("PICKUPS: ", s.pickups);

                    if (s.pickups == 1) {
                        if (s.locations && s.locations.length > 0) {
                            console.log("LOCATIONS: ", s.locations);

                            for (const loc of s.locations) {
                                console.log("LOCATION VALUE", loc);

                                const addr1 = loc.address1 ?? "";
                                const addr2 = loc.address2 ? `, ${loc.address2}` : "";
                                const csz = [loc.city, loc.state, loc.zipCode].filter(Boolean).join(", ");
                                const company = loc.companyName ? `${loc.companyName} — ` : "";

                                y -= 10;

                                let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ""}`;

                                const maxLen = 45;
                                const chunks = [];
                                let text = addressText.trim();

                                page.drawLine({
                                    start: { x: 50, y },
                                    end: { x: 390, y },
                                    thickness: 1,
                                    dashPhase: 0,
                                });

                                while (text.length > maxLen) {
                                    let splitIndex = text.lastIndexOf(" ", maxLen);

                                    if (splitIndex === -1) {
                                        splitIndex = maxLen;
                                    }

                                    chunks.push(text.slice(0, splitIndex).trim());
                                    text = text.slice(splitIndex).trim();
                                }

                                if (text.length) chunks.push(text);

                                chunks.forEach(lineText => {
                                    line(" " + lineText);
                                });

                                page.drawLine({
                                    start: { x: 50, y: y - 5 },
                                    end: { x: 390, y: y - 5 },
                                    thickness: 1,
                                    dashPhase: 0,
                                });

                                page.drawLine({
                                    start: { x: 50, y: y - 5 },
                                    end: { x: 50, y: y + lineH * chunks.length },
                                    thickness: 1,
                                    dashPhase: 0,
                                });

                                page.drawLine({
                                    start: { x: 390, y: y - 5 },
                                    end: { x: 390, y: y + lineH * chunks.length },
                                    thickness: 1,
                                    dashPhase: 0,
                                });
                            }
                        }
                    }

                    const shipList = Array.isArray(s.shipments) ? s.shipments : [];

                    if (shipList.length === 0 && s.pickups == null && s.waypoint !== "*") {
                        line("Depot " + s.waypoint);
                        y -= 6;

                        const w = page.getWidth();

                        page.drawLine({
                            start: { x: 50, y },
                            end: { x: w - 50, y },
                            thickness: 1,
                            dashPhase: 0,
                        });

                        continue;
                    }

                    const hasStopNumber = s.stop !== null && s.stop !== undefined && !isNaN(Number(s.stop));

                    if (!hasStopNumber) {
                        continue;
                    }

                    for (const sh of shipList) {
                        const id = sh?.shipmentID ?? "(no id)";
                        const a = sh?.address ?? {};
                        const addr1 = a.address1 ?? "";
                        const addr2 = a.address2 ? `, ${a.address2}` : "";
                        const csz = [a.city, a.state, a.zipCode].filter(Boolean).join(", ");
                        const company = a.companyName ? `${a.companyName} — ` : "";

                        let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ""}`;

                        const maxLen = 45;
                        const chunks = [];
                        let text = addressText.trim();

                        while (text.length > maxLen) {
                            let splitIndex = text.lastIndexOf(" ", maxLen);

                            if (splitIndex === -1) {
                                splitIndex = maxLen;
                            }

                            chunks.push(text.slice(0, splitIndex).trim());
                            text = text.slice(splitIndex).trim();
                        }

                        if (text.length) chunks.push(text);

                        const pngBytes = await this.makePdf417PngBytes(id);
                        const img = await pdf.embedPng(pngBytes);

                        const targetW = 150;
                        const scale = targetW / img.width;
                        const drawW = targetW;
                        const drawH = img.height * scale;

                        const textBlockH =
                            lineH +
                            (sh.signatureRequired ? 10 : 0) +
                            (sh.isPriority ? 10 : 0) +
                            10 +
                            (chunks.length * lineH) +
                            10;

                        const blockH = Math.max(textBlockH, drawH + 16);

                        if (y - blockH < margin) {
                            page = pdf.addPage();
                            y = page.getHeight() - margin;
                        }

                        const textTopY = y;

                        line(`Shipment ID:  ${id}`);

                        if (sh.signatureRequired) {
                            drawSafeText("Signature Required", {
                                x: 425,
                                y: y,
                                size: 10,
                                font: fontBold
                            });
                            y -= 10;
                        }

                        if (sh.isPriority) {
                            drawSafeText("Priority", {
                                x: 425,
                                y: y,
                                size: 10,
                                font: fontBold
                            });
                            y -= 10;
                        }

                        if (Array.isArray(sh.additionalServices) && sh.additionalServices.includes("LOCVISIT")) {
                            drawSafeText("Location", {
                                x: 425,
                                y: y,
                                size: 10,
                                font: fontBold
                            });
                            y -= 10;
                        }

                        if (sh.isDelivery == false) {
                            drawSafeText("Pickup", {
                                x: 425,
                                y: y,
                                size: 10,
                                font: fontBold
                            });
                            y -= 10;
                        }

                        y -= 10;

                        page.drawLine({
                            start: { x: 50, y },
                            end: { x: 390, y },
                            thickness: 1,
                            dashPhase: 0,
                        });

                        const addressBoxTopY = y;

                        chunks.forEach(lineText => {
                            line(" " + lineText);
                        });

                        page.drawLine({
                            start: { x: 50, y: y - 5 },
                            end: { x: 390, y: y - 5 },
                            thickness: 1,
                            dashPhase: 0,
                        });

                        page.drawLine({
                            start: { x: 50, y: y - 5 },
                            end: { x: 50, y: addressBoxTopY },
                            thickness: 1,
                            dashPhase: 0,
                        });

                        page.drawLine({
                            start: { x: 390, y: y - 5 },
                            end: { x: 390, y: addressBoxTopY },
                            thickness: 1,
                            dashPhase: 0,
                        });

                        const rightX = page.getWidth() - margin - drawW;
                        const barcodeY = addressBoxTopY - drawH;

                        page.drawImage(img, {
                            x: rightX,
                            y: barcodeY,
                            width: drawW,
                            height: drawH,
                        });

                        const textY = barcodeY - 12;

                        drawSafeText(`${id}`, {
                            x: rightX + 50,
                            y: textY + 3,
                            size: 10,
                            font
                        });

                        y = textTopY - blockH - 24;
                    }

                    y -= 8;

                    const w = page.getWidth();

                    page.drawLine({
                        start: { x: 50, y },
                        end: { x: w - 50, y },
                        thickness: 1,
                        dashPhase: 0,
                    });
                }

                if (statusFiveStops.length > 0) {
                    page = pdf.addPage();
                    y = page.getHeight() - margin;

                    line("Unassigned Shipments", { bold: true, size: 14 });
                    line("These shipments were unable to be assigned a stop.", { size: 10 });

                    y -= 10;

                    for (const s of statusFiveStops) {
                        const shipList = Array.isArray(s.shipments) ? s.shipments : [];

                        const header = Number.isFinite(s.stop) ? `Stop ${s.stop}` : "Stop Unassigned";

                        line(`${header}`, { bold: true, size: 12 });

                        for (const sh of shipList) {
                            const id = sh?.shipmentID ?? "(no id)";
                            const a = sh?.address ?? {};
                            const addr1 = a.address1 ?? "";
                            const addr2 = a.address2 ? `, ${a.address2}` : "";
                            const csz = [a.city, a.state, a.zipCode].filter(Boolean).join(", ");
                            const company = a.companyName ? `${a.companyName} — ` : "";

                            let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ""}`;

                            const maxLen = 45;
                            const chunks = [];
                            let text = addressText.trim();

                            while (text.length > maxLen) {
                                let splitIndex = text.lastIndexOf(" ", maxLen);

                                if (splitIndex === -1) {
                                    splitIndex = maxLen;
                                }

                                chunks.push(text.slice(0, splitIndex).trim());
                                text = text.slice(splitIndex).trim();
                            }

                            if (text.length) chunks.push(text);

                            const pngBytes = await this.makePdf417PngBytes(id);
                            const img = await pdf.embedPng(pngBytes);

                            const targetW = 150;
                            const scale = targetW / img.width;
                            const drawW = targetW;
                            const drawH = img.height * scale;

                            const textBlockH =
                                lineH +
                                (sh.signatureRequired ? 10 : 0) +
                                (sh.isPriority ? 10 : 0) +
                                10 +
                                (chunks.length * lineH) +
                                10;

                            const blockH = Math.max(textBlockH, drawH + 16);

                            if (y - blockH < margin) {
                                page = pdf.addPage();
                                y = page.getHeight() - margin;
                            }

                            const textTopY = y;

                            line(`Shipment ID:  ${id}`);

                            if (sh.signatureRequired) {
                                drawSafeText("Signature Required", {
                                    x: 425,
                                    y: y,
                                    size: 10,
                                    font: fontBold
                                });
                                y -= 10;
                            }

                            if (sh.isPriority) {
                                drawSafeText("Priority", {
                                    x: 425,
                                    y: y,
                                    size: 10,
                                    font: fontBold
                                });
                                y -= 10;
                            }

                            if (Array.isArray(sh.additionalServices) && sh.additionalServices.includes("LOCVISIT")) {
                                drawSafeText("Location", {
                                    x: 425,
                                    y: y,
                                    size: 10,
                                    font: fontBold
                                });
                                y -= 10;
                            }

                            if (sh.isDelivery == false) {
                                drawSafeText("Pickup", {
                                    x: 425,
                                    y: y,
                                    size: 10,
                                    font: fontBold
                                });
                                y -= 10;
                            }

                            y -= 10;

                            page.drawLine({
                                start: { x: 50, y },
                                end: { x: 390, y },
                                thickness: 1,
                                dashPhase: 0,
                            });

                            const addressBoxTopY = y;

                            chunks.forEach(lineText => {
                                line(" " + lineText);
                            });

                            page.drawLine({
                                start: { x: 50, y: y - 5 },
                                end: { x: 390, y: y - 5 },
                                thickness: 1,
                                dashPhase: 0,
                            });

                            page.drawLine({
                                start: { x: 50, y: y - 5 },
                                end: { x: 50, y: addressBoxTopY },
                                thickness: 1,
                                dashPhase: 0,
                            });

                            page.drawLine({
                                start: { x: 390, y: y - 5 },
                                end: { x: 390, y: addressBoxTopY },
                                thickness: 1,
                                dashPhase: 0,
                            });

                            const rightX = page.getWidth() - margin - drawW;
                            const barcodeY = addressBoxTopY - drawH;

                            page.drawImage(img, {
                                x: rightX,
                                y: barcodeY,
                                width: drawW,
                                height: drawH,
                            });

                            const textY = barcodeY - 12;

                            drawSafeText(`${id}`, {
                                x: rightX + 50,
                                y: textY + 3,
                                size: 10,
                                font
                            });

                            y = textTopY - blockH - 34;
                        }

                        y -= 8;
                    }
                }

                const bytes = await pdf.save();
                const blob = new Blob([bytes], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);
                window.open(url);
            } catch (error) {
                console.error("PDF generation failed:", error);
                console.error(error?.stack);
                alert(error?.message || "Unable to generate PDF.");
            }
        },
        // async createStopsPdf() {
        //     let stops = this.tripShipments;
        //     const sorted = [...stops].sort((a, b) => (a.stop ?? 0) - (b.stop ?? 0));
        //     const statusFiveStops = sorted.filter(s => String(s.status) === "5");

        //     const allShipments = sorted.flatMap(s =>
        //         Array.isArray(s.shipments) ? s.shipments : []
        //     );

        //     const locationVisitCount = allShipments.filter(sh =>
        //         Array.isArray(sh.additionalServices) &&
        //         sh.additionalServices.includes("LOCVISIT")
        //     ).length;

        //     const customerPickupCount = allShipments.filter(sh =>
        //         sh.isDelivery === false &&
        //         !(
        //             Array.isArray(sh.additionalServices) &&
        //             sh.additionalServices.includes("LOCVISIT")
        //         )
        //     ).length;

        //     const deliveryCount = allShipments.filter(sh =>
        //         sh.isDelivery === true &&
        //         !(
        //             Array.isArray(sh.additionalServices) &&
        //             sh.additionalServices.includes("LOCVISIT")
        //         )
        //     ).length;

        //     // Setup doc + fonts
        //     const pdf = await PDFDocument.create();
        //     let page = pdf.addPage();
        //     const font = await pdf.embedFont(StandardFonts.Helvetica);
        //     const fontBold = await pdf.embedFont(StandardFonts.HelveticaBold);

        //     // Layout
        //     const margin = 50;
        //     const lineH = 16;
        //     let y = page.getHeight() - margin;

        //     // Adds new page as needed
        //     const line = (text, { bold=false, size=12 } = {}) => {
        //         if (y < margin + lineH) {
        //         page = pdf.addPage();
        //         y = page.getHeight() - margin;
        //         }
        //         page.drawText(text, { x: margin, y: y - lineH, size, font: bold ? fontBold : font });
        //         y -= lineH;
        //     };

        //     for (const s of sorted) {
        //         if(s.waypoint == "*"){
        //             const toLocalTime = t => {
        //             const [h, m] = t.split(':');
        //             const d = new Date();
        //                 d.setHours(h, m);
        //                 return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        //             };

        //             const time = [s.startTime, s.endTime]
        //             .filter(Boolean)
        //             .map(toLocalTime)
        //             .join(' – ');

        //             const createdLocal = new Date(s.created).toLocaleString([], {
        //                 year: 'numeric',
        //                 month: 'numeric',
        //                 day: 'numeric',
        //                 hour: 'numeric',
        //                 minute: '2-digit'
        //             });

        //             line('LREX ' + createdLocal + ' Route ' + s.route + ' ( ' + time + ' )', { bold: true, size: 12 });
        //             line(`Location Visits: ${locationVisitCount}`, { bold: true, size: 10 });
        //             line(`Customer Pickups: ${customerPickupCount}`, { bold: true, size: 10 });
        //             line(`Deliveries: ${deliveryCount}`, { bold: true, size: 10 });
        //             y -= 6;
        //         }

        //         if (s.waypoint === "*" && s.totalDistance && s.totalTime) {
        //             const totalTime = Number(s.totalTime / 60).toFixed(2);
        //             const totalDistance = Number(s.totalDistance).toFixed(2);

        //             const timeText = `Total Time: ${totalTime} hours`;
        //             const distText = `Total Miles: ${totalDistance}`;
        //             const fontSize = 12;

        //             // Measure width of right-side text to align it properly
        //             const rightTextWidth = font.widthOfTextAtSize(distText, fontSize);

        //             // Left side
        //             const leftX = margin;
        //             const rightX = page.getWidth() - margin - rightTextWidth;

        //             page.drawText(timeText, { x: leftX, y: y - lineH, size: fontSize, font });
        //             page.drawText(distText, { x: rightX, y: y - lineH, size: fontSize, font });

        //             y -= lineH + 6;
        //         }
        //         const width = page.getWidth();
        //         page.drawLine({
        //             start: { x: 50, y },
        //             end:   { x: width - 50, y },
        //             thickness: 1,
        //             dashPhase: 0,
        //         });
        //         //const header = s.waypoint === "*" ? "" : Number.isFinite(s.stop) ? `Stop ${s.stop}` : "Stop";
        //         const header = Number.isFinite(s.stop) && s.waypoint !== "*"
        //         ? `Stop ${s.stop}`
        //         : "";
        //         const toLocalTime = t => {
        //             const [h, m] = t.split(':');
        //             const d = new Date();
        //             d.setHours(h, m);
        //             return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        //         };

        //         const time = [s.windowStart, s.windowEnd]
        //         .filter(Boolean)
        //         .map(toLocalTime)
        //         .join(' – ');

        //         const arrivalTime = [s.arrival]
        //         .filter(Boolean)
        //         .map(toLocalTime);

        //         if (s.stop !== null && s.stop !== undefined && !isNaN(Number(s.stop))) {
        //             line(`${header} ${arrivalTime} ${time ? ` (${time})` : ''}`, {
        //                 bold: true,
        //                 size: 13
        //             });
        //         }
        //         //line(`${header} ${arrivalTime} ${time ? ` (${time})` : ''}`, { bold: true, size: 13 });
                
        //         console.log("PICKUPS: ", s.pickups)
        //         if(s.pickups == 1){
        //             // const shipList = Array.isArray(s.shipments) ? s.shipments : [];
        //             // for (const sh of shipList) {
        //             //     if (
        //             //         Array.isArray(sh.additionalServices) &&
        //             //         sh.additionalServices.includes("LOCVISIT")
        //             //     ) {
        //             //         line("Location")
        //             //     }
        //             // }

        //             if(s.locations && s.locations.length > 0){
        //                 console.log("LOCATIONS: ", s.locations)
        //                 for(const loc of s.locations){
        //                     console.log("LOCATION VALUE", loc)
        //                     const addr1 = loc.address1 ?? '';
        //                     const addr2 = loc.address2 ? `, ${loc.address2}` : '';
        //                     const csz = [loc.city, loc.state, loc.zipCode].filter(Boolean).join(', ');
        //                     const company = loc.companyName ? `${loc.companyName} — ` : '';
        //                     y -= 10
        //                     let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

        //                     const maxLen = 45;
        //                     const chunks = [];
        //                     let text = addressText.trim();
        //                     page.drawLine({
        //                         start: { x: 50, y },
        //                         end:   { x: 390, y },
        //                         thickness: 1,
        //                         dashPhase: 0,
        //                     });
        //                     while (text.length > maxLen) {
        //                         // find the last space before the 45th character
        //                         let splitIndex = text.lastIndexOf(' ', maxLen);

        //                         if (splitIndex === -1) {
        //                         splitIndex = maxLen;
        //                         }

        //                         chunks.push(text.slice(0, splitIndex).trim());

        //                         text = text.slice(splitIndex).trim();
        //                     }

        //                     if (text.length) chunks.push(text);

        //                     chunks.forEach(lineText => {
        //                         line(" " + lineText);
        //                     });

        //                     page.drawLine({
        //                         start: { x: 50, y: y - 5 },
        //                         end:   { x: 390, y: y - 5},
        //                         thickness: 1,
        //                         dashPhase: 0,
        //                     });

        //                     page.drawLine({
        //                         start: { x: 50, y: y - 5},
        //                         end:   { x: 50, y: y + lineH * chunks.length },
        //                         thickness: 1,
        //                         dashPhase: 0,
        //                     });

        //                     page.drawLine({
        //                         start: { x: 390, y: y - 5 },
        //                         end:   { x: 390, y: y + lineH * chunks.length },
        //                         thickness: 1,
        //                         dashPhase: 0,
        //                     });
        //                 }
        //             }
        //         }

        //         const shipList = Array.isArray(s.shipments) ? s.shipments : [];
        //         if (shipList.length === 0 && s.pickups == null && (s.waypoint !== "*")) {
        //             line('Depot ' + s.waypoint);
        //             y -= 6;
        //             const w = page.getWidth();
        //             page.drawLine({
        //                 start: { x: 50, y },
        //                 end:   { x: w - 50, y },
        //                 thickness: 1,
        //                 dashPhase: 0,
        //             });
        //             continue;
        //         }

        //         const hasStopNumber = s.stop !== null && s.stop !== undefined && !isNaN(Number(s.stop));

        //         if (!hasStopNumber) {
        //             continue;
        //         }

        //         for (const sh of shipList) {
        //             const id = sh?.shipmentID ?? '(no id)';
        //             const a = sh?.address ?? {};
        //             const addr1 = a.address1 ?? '';
        //             const addr2 = a.address2 ? `, ${a.address2}` : '';
        //             const csz = [a.city, a.state, a.zipCode].filter(Boolean).join(', ');
        //             const company = a.companyName ? `${a.companyName} — ` : '';

        //             let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

        //             const maxLen = 45;
        //             const chunks = [];
        //             let text = addressText.trim();

        //             while (text.length > maxLen) {
        //                 let splitIndex = text.lastIndexOf(' ', maxLen);

        //                 if (splitIndex === -1) {
        //                     splitIndex = maxLen;
        //                 }

        //                 chunks.push(text.slice(0, splitIndex).trim());
        //                 text = text.slice(splitIndex).trim();
        //             }

        //             if (text.length) chunks.push(text);

        //             // Create PNG barcode before drawing anything
        //             const pngBytes = await this.makePdf417PngBytes(id);
        //             const img = await pdf.embedPng(pngBytes);

        //             const targetW = 150;
        //             const scale = targetW / img.width;
        //             const drawW = targetW;
        //             const drawH = img.height * scale;

        //             const textBlockH =
        //                 lineH + // Shipment ID
        //                 (sh.signatureRequired ? 10 : 0) +
        //                 (sh.isPriority ? 10 : 0) +
        //                 10 + // spacing before address
        //                 (chunks.length * lineH) +
        //                 10; // bottom padding

        //             const blockH = Math.max(textBlockH, drawH + 16);

        //             // Move the whole shipment block to the next page before drawing
        //             if (y - blockH < margin) {
        //                 page = pdf.addPage();
        //                 y = page.getHeight() - margin;
        //             }

        //             const textTopY = y;

        //             line(`Shipment ID:  ${id}`);

        //             if (sh.signatureRequired) {
        //                 page.drawText("Signature Required", {
        //                     x: 425,
        //                     y: y,
        //                     size: 10,
        //                     font: fontBold
        //                 });
        //                 y -= 10;
        //             }

        //             if (sh.isPriority) {
        //                 page.drawText("Priority", {
        //                     x: 425,
        //                     y: y,
        //                     size: 10,
        //                     font: fontBold
        //                 });
        //                 y -= 10;
        //             }

        //             if (Array.isArray(sh.additionalServices) && sh.additionalServices.includes("LOCVISIT")) {
        //                 page.drawText("Location", {
        //                     x: 425,
        //                     y: y,
        //                     size: 10,
        //                     font: fontBold
        //                 });
        //                 y -= 10;
        //             }

        //             if (sh.isDelivery == false) {
        //                 page.drawText("Pickup", {
        //                     x: 425,
        //                     y: y,
        //                     size: 10,
        //                     font: fontBold
        //                 });
        //                 y -= 10;
        //             }

        //             y -= 10;

        //             page.drawLine({
        //                 start: { x: 50, y },
        //                 end: { x: 390, y },
        //                 thickness: 1,
        //                 dashPhase: 0,
        //             });

        //             const addressBoxTopY = y;

        //             chunks.forEach(lineText => {
        //                 line(" " + lineText);
        //             });

        //             page.drawLine({
        //                 start: { x: 50, y: y - 5 },
        //                 end: { x: 390, y: y - 5 },
        //                 thickness: 1,
        //                 dashPhase: 0,
        //             });

        //             page.drawLine({
        //                 start: { x: 50, y: y - 5 },
        //                 end: { x: 50, y: addressBoxTopY },
        //                 thickness: 1,
        //                 dashPhase: 0,
        //             });

        //             page.drawLine({
        //                 start: { x: 390, y: y - 5 },
        //                 end: { x: 390, y: addressBoxTopY },
        //                 thickness: 1,
        //                 dashPhase: 0,
        //             });

        //             // Place barcode to the right, aligned with the address box
        //             const rightX = page.getWidth() - margin - drawW;
        //             const barcodeY = addressBoxTopY - drawH;

        //             page.drawImage(img, {
        //                 x: rightX,
        //                 y: barcodeY,
        //                 width: drawW,
        //                 height: drawH,
        //             });

        //             const textY = barcodeY - 12;

        //             page.drawText(`${id}`, {
        //                 x: rightX + 50,
        //                 y: textY + 3,
        //                 size: 10,
        //                 font
        //             });

        //             y = textTopY - blockH - 24;
        //         }

        //         y -= 8; // spacing between stops
        //         const w = page.getWidth();
        //         page.drawLine({
        //             start: { x: 50, y },
        //             end:   { x: w - 50, y },
        //             thickness: 1,
        //             dashPhase: 0,
        //         });
        //     }

        //     if (statusFiveStops.length > 0) {
        //         page = pdf.addPage();
        //         y = page.getHeight() - margin;

        //         line("Unassigned Shipments", { bold: true, size: 14 });
        //         line("These shipments were unable to be assigned a stop.", { size: 10 });
        //         y -= 10;

        //         for (const s of statusFiveStops) {
        //             const shipList = Array.isArray(s.shipments) ? s.shipments : [];

        //             const header = Number.isFinite(s.stop) ? `Stop ${s.stop}` : "Stop Unassigned";
        //             line(`${header}`, { bold: true, size: 12 });

        //             for (const sh of shipList) {
        //                 // if (
        //                 //     Array.isArray(sh.additionalServices) &&
        //                 //     sh.additionalServices.includes("LOCVISIT")
        //                 // ) {
        //                 //     line("Location")
        //                 // }
        //                 const id = sh?.shipmentID ?? '(no id)';
        //                 const a = sh?.address ?? {};
        //                 const addr1 = a.address1 ?? '';
        //                 const addr2 = a.address2 ? `, ${a.address2}` : '';
        //                 const csz = [a.city, a.state, a.zipCode].filter(Boolean).join(', ');
        //                 const company = a.companyName ? `${a.companyName} — ` : '';

        //                 let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

        //                 const maxLen = 45;
        //                 const chunks = [];
        //                 let text = addressText.trim();

        //                 while (text.length > maxLen) {
        //                     let splitIndex = text.lastIndexOf(' ', maxLen);

        //                     if (splitIndex === -1) {
        //                         splitIndex = maxLen;
        //                     }

        //                     chunks.push(text.slice(0, splitIndex).trim());
        //                     text = text.slice(splitIndex).trim();
        //                 }

        //                 if (text.length) chunks.push(text);

        //                 // Create PNG barcode before drawing anything
        //                 const pngBytes = await this.makePdf417PngBytes(id);
        //                 const img = await pdf.embedPng(pngBytes);

        //                 const targetW = 150;
        //                 const scale = targetW / img.width;
        //                 const drawW = targetW;
        //                 const drawH = img.height * scale;

        //                 const textBlockH =
        //                     lineH + // Shipment ID
        //                     (sh.signatureRequired ? 10 : 0) +
        //                     (sh.isPriority ? 10 : 0) +
        //                     10 + // spacing before address
        //                     (chunks.length * lineH) +
        //                     10; // bottom padding

        //                 const blockH = Math.max(textBlockH, drawH + 16);

        //                 // Move the whole shipment block to the next page before drawing
        //                 if (y - blockH < margin) {
        //                     page = pdf.addPage();
        //                     y = page.getHeight() - margin;
        //                 }

        //                 const textTopY = y;

        //                 line(`Shipment ID:  ${id}`);

        //                 if (sh.signatureRequired) {
        //                     page.drawText("Signature Required", {
        //                         x: 425,
        //                         y: y,
        //                         size: 10,
        //                         font: fontBold
        //                     });
        //                     y -= 10;
        //                 }

        //                 if (sh.isPriority) {
        //                     page.drawText("Priority", {
        //                         x: 425,
        //                         y: y,
        //                         size: 10,
        //                         font: fontBold
        //                     });
        //                     y -= 10;
        //                 }

        //                 if (Array.isArray(sh.additionalServices) && sh.additionalServices.includes("LOCVISIT")) {
        //                     page.drawText("Location", {
        //                         x: 425,
        //                         y: y,
        //                         size: 10,
        //                         font: fontBold
        //                     });
        //                     y -= 10;
        //                 }

        //                 if (sh.isDelivery == false) {
        //                     page.drawText("Pickup", {
        //                         x: 425,
        //                         y: y,
        //                         size: 10,
        //                         font: fontBold
        //                     });
        //                     y -= 10;
        //                 }

        //                 y -= 10;

        //                 page.drawLine({
        //                     start: { x: 50, y },
        //                     end: { x: 390, y },
        //                     thickness: 1,
        //                     dashPhase: 0,
        //                 });

        //                 const addressBoxTopY = y;

        //                 chunks.forEach(lineText => {
        //                     line(" " + lineText);
        //                 });

        //                 page.drawLine({
        //                     start: { x: 50, y: y - 5 },
        //                     end: { x: 390, y: y - 5 },
        //                     thickness: 1,
        //                     dashPhase: 0,
        //                 });

        //                 page.drawLine({
        //                     start: { x: 50, y: y - 5 },
        //                     end: { x: 50, y: addressBoxTopY },
        //                     thickness: 1,
        //                     dashPhase: 0,
        //                 });

        //                 page.drawLine({
        //                     start: { x: 390, y: y - 5 },
        //                     end: { x: 390, y: addressBoxTopY },
        //                     thickness: 1,
        //                     dashPhase: 0,
        //                 });

        //                 // Place barcode to the right, aligned with the address box
        //                 const rightX = page.getWidth() - margin - drawW;
        //                 const barcodeY = addressBoxTopY - drawH;

        //                 page.drawImage(img, {
        //                     x: rightX,
        //                     y: barcodeY,
        //                     width: drawW,
        //                     height: drawH,
        //                 });

        //                 const textY = barcodeY - 12;

        //                 page.drawText(`${id}`, {
        //                     x: rightX + 50,
        //                     y: textY + 3,
        //                     size: 10,
        //                     font
        //                 });

        //                 y = textTopY - blockH - 34;
        //             }

        //             y -= 8;
        //         }
        //     }

        //     // Open in new tab
        //     const bytes = await pdf.save();
        //     const blob = new Blob([bytes], { type: 'application/pdf' });
        //     const url = URL.createObjectURL(blob);
        //     window.open(url);
        // },
        async runFilter(event) {
            await this.filterValues(event);
        },
        async filterValues(event){
            console.log("FILTER")
            this.isFiltered = true;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;

            switch (event.filterField) {
                case "tripSheetID":
                    this.listTripWaypointsFunc(this.filterValue);
                    this.isFiltered = false;
                    break;
                default:
                    break;
            }
        },
        async listTripWaypointsFunc(tripSheetID) {
            this.loadingData = true;
            this.tripShipments = [];
            let graphqlQuery = `query listTripWaypoints($nextToken: String, $tripSheetID: String) {
                listTripWaypoints(nextToken: $nextToken, tripSheetID: $tripSheetID) {
                    items{
                    tripSheetID
                    stop
                    longitude
                    latitude
                    created
                    startTime
                    endTime
                    route
                    waypoint
                    pickups
                    arrival
                    departure
                    status
                    stopType
                    serviceStatus
                    totalDistance
                    totalTime
                    isDelivery
                    windowEnd
                    windowStart
                    locations{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                    }
                    address{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                      }
                    shipments{
                        shipmentID
                        isPriority
                        isDelivery
                        signatureRequired
                        additionalServices
                        lastActivity{
                            activityTime
                            description
                            shippingEvent
                            code
                        }
                      address{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                      }
                    }
                }
                    nextToken
                }
            }`;

            try {
                let allTripShipments = [];
                let nextToken = null;

                do {
                    let response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                        variables: { nextToken, tripSheetID }
                    });

                    const data = response.data.listTripWaypoints;
                    allTripShipments = [...allTripShipments, ...data.items];
                    nextToken = data.nextToken;

                } while (nextToken); 

                this.tripShipments = allTripShipments;
                allTripShipments.sort((a, b) =>  a.stop - b.stop);
                this.tripShipments = allTripShipments;
                this.loadingData = false;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting trip shipments.";
                this.loadingData = false;
            }
        },
        formatLocalTime(utcDate) {
            const date = new Date(utcDate);

            const formattedDate = date.toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true
            });

            return formattedDate;
        },
        formatLocalTimeArrival(time24) {
            const [hours, minutes] = time24.split(":");
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);

            // Format to a readable local 12-hour time
            const localTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

            return localTime;
        },
        trackShipment(shipmentID){
            this.toggleTrackShipment = true;
            this.trackShipmentID = shipmentID;
        },
        closeShipmentInfo(event){
            this.toggleTrackShipment = event;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest() {
            this.loadingTable = true;

            try {
                let csvArray = [];

                for (const waypoint of (this.tripShipments || [])) {
                    const shipments = Array.isArray(waypoint?.shipments) ? waypoint.shipments : [];

                    if (shipments.length) {
                        for (const shipment of shipments) {
                            csvArray.push({
                                stop: waypoint?.stop ?? "",
                                arrival: waypoint?.arrival ?? "",
                                shipmentID: shipment?.shipmentID ?? "",
                                route: waypoint?.route ?? "",

                                ShipmentStatus: shipment?.lastActivity?.description ?? "",

                                DeliveryCompanyName: shipment?.address?.companyName ?? waypoint?.address?.companyName ?? waypoint?.locations?.companyName ?? "",
                                DeliveryAddress1: shipment?.address?.address1 ?? waypoint?.address?.address1 ?? waypoint?.locations?.address1 ?? "",
                                DeliveryAddress2: shipment?.address?.address2 ?? waypoint?.address?.address2 ?? waypoint?.locations?.address2 ?? "",
                                DeliveryCity: shipment?.address?.city ?? waypoint?.address?.city ?? waypoint?.locations?.city ?? "",
                                DeliveryState: shipment?.address?.state ?? waypoint?.address?.state ?? waypoint?.locations?.state ?? "",
                                DeliveryZipCode: shipment?.address?.zipCode ?? waypoint?.address?.zipCode ?? waypoint?.locations?.zipCode ?? "",
                                TripSheetID: waypoint?.tripSheetID ?? "",
                                Status: waypoint?.serviceStatus ?? ""
                            });
                        }
                    } else {
                        csvArray.push({
                            stop: waypoint?.stop ?? "",
                            arrival: waypoint?.arrival ?? "",
                            shipmentID: "",
                            route: waypoint?.route ?? "",

                            ShipmentStatus: "",

                            DeliveryCompanyName: waypoint?.address?.companyName ?? waypoint?.locations?.companyName ?? "",
                            DeliveryAddress1: waypoint?.address?.address1 ?? waypoint?.locations?.address1 ?? "",
                            DeliveryAddress2: waypoint?.address?.address2 ?? waypoint?.locations?.address2 ?? "",
                            DeliveryCity: waypoint?.address?.city ?? waypoint?.locations?.city ?? "",
                            DeliveryState: waypoint?.address?.state ?? waypoint?.locations?.state ?? "",
                            DeliveryZipCode: waypoint?.address?.zipCode ?? waypoint?.locations?.zipCode ?? "",
                            TripSheetID: waypoint?.tripSheetID ?? "",
                            Status: waypoint?.serviceStatus ?? ""
                        });
                    }
                }

                jsonexport(csvArray, (error, csv) => {
                    if (error) {
                        console.log(error);
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error downloading manifest shipments";
                        this.loadingTable = false;
                        return;
                    }

                    const blob = new Blob([csv], { type: "text/csv" });
                    const anchor = document.createElement("a");
                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = "TripSheetData.csv";
                    anchor.click();
                    window.URL.revokeObjectURL(anchor.href);
                    anchor.remove();
                    this.loadingTable = false;
                });

            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error downloading manifest shipments";
                this.loadingTable = false;
            }
        }
        // async downloadCSVTest() {
        //     console.log("HELLO");
        //     this.loadingTable = true;

        //     try {
        //         let csvArray = [];

        //         for (const waypoint of (this.tripShipments || [])) {
        //             const shipments = Array.isArray(waypoint?.shipments) ? waypoint.shipments : [];

        //             // If there are shipments, create one row per shipment
        //             if (shipments.length) {
        //                 for (const shipment of shipments) {
        //                     csvArray.push({
        //                         stop: waypoint?.stop ?? "",
        //                         arrival: waypoint?.arrival ?? "",
        //                         shipmentID: shipment?.shipmentID ?? "",
        //                         route: waypoint?.route ?? "",
        //                         DeliveryCompanyName: shipment?.address?.companyName ?? waypoint?.address?.companyName ?? waypoint?.locations?.companyName ?? "",
        //                         DeliveryAddress1: shipment?.address?.address1 ?? waypoint?.address?.address1 ?? waypoint?.locations?.address1 ?? "",
        //                         DeliveryAddress2: shipment?.address?.address2 ?? waypoint?.address?.address2 ?? waypoint?.locations?.address2 ?? "",
        //                         DeliveryCity: shipment?.address?.city ?? waypoint?.address?.city ?? waypoint?.locations?.city ?? "",
        //                         DeliveryState: shipment?.address?.state ?? waypoint?.address?.state ?? waypoint?.locations?.state ?? "",
        //                         DeliveryZipCode: shipment?.address?.zipCode ?? waypoint?.address?.zipCode ?? waypoint?.locations?.zipCode ?? "",
        //                         TripSheetID: waypoint?.tripSheetID ?? "",
        //                         Status: waypoint?.serviceStatus ?? ""
        //                     });
        //                 }
        //             } else {
        //                 // If no shipments exist, still create a row from waypoint data
        //                 csvArray.push({
        //                     stop: waypoint?.stop ?? "",
        //                     arrival: waypoint?.arrival ?? "",
        //                     shipmentID: "",
        //                     route: waypoint?.route ?? "",
        //                     DeliveryCompanyName: waypoint?.address?.companyName ?? waypoint?.locations?.companyName ?? "",
        //                     DeliveryAddress1: waypoint?.address?.address1 ?? waypoint?.locations?.address1 ?? "",
        //                     DeliveryAddress2: waypoint?.address?.address2 ?? waypoint?.locations?.address2 ?? "",
        //                     DeliveryCity: waypoint?.address?.city ?? waypoint?.locations?.city ?? "",
        //                     DeliveryState: waypoint?.address?.state ?? waypoint?.locations?.state ?? "",
        //                     DeliveryZipCode: waypoint?.address?.zipCode ?? waypoint?.locations?.zipCode ?? "",
        //                     TripSheetID: waypoint?.tripSheetID ?? "",
        //                     Status: waypoint?.serviceStatus ?? ""
        //                 });
        //             }
        //         }

        //         jsonexport(csvArray, (error, csv) => {
        //             if (error) {
        //                 console.log(error);
        //                 this.toggleAlertBox = true;
        //                 this.alertMessage = "Error downloading manifest shipments";
        //                 this.loadingTable = false;
        //                 return;
        //             }

        //             const blob = new Blob([csv], { type: "text/csv" });
        //             const anchor = document.createElement("a");
        //             anchor.href = window.URL.createObjectURL(blob);
        //             anchor.download = "TripSheetData.csv";
        //             anchor.click();
        //             window.URL.revokeObjectURL(anchor.href);
        //             anchor.remove();
        //             this.loadingTable = false;
        //         });

        //     } catch (e) {
        //         console.log(e);
        //         this.toggleAlertBox = true;
        //         this.alertMessage = "Error downloading manifest shipments";
        //         this.loadingTable = false;
        //     }
        // }
    }
}
</script>

<style scoped>
.highlight-row {
    background-color: #b9b9b9 !important;
    transition: background-color 0.5s ease-in-out;
}

.search-shipments {
    border: 1px solid #e2e2e2;
    padding: 5px;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
    outline: none;
    margin-bottom: 5px;
}

.status-filter-container {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    animation: animate-table-row 1s ease;
}

.status-filter-button {
    border: 1px solid #cfcfcf;
    background: #f7f7f7;
    color: #6a6a6a;
    padding: 6px 14px;
    border-radius: 999px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s ease;
}

.status-filter-button:hover {
    transform: translateY(-1px);
    filter: brightness(0.97);
}

.status-filter-button.active {
    color: #fff;
    border-color: transparent;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 8px;
}

/* All */
.status-filter-button.active:not(.delivered):not(.in-transit) {
    background: #32ccfe;
}

/* Delivered */
.status-filter-button.delivered.active {
    background: #33f18a;
    color: #155724;
}

/* In Transit */
.status-filter-button.in-transit.active {
    background: #ffb84d;
    color: #5c3b00;
}

.status-filter-button:active {
    transform: scale(0.97);
}

.table-container-main {
	width: 100%;
	margin-top: 0;
	overflow-x: hidden;
	resize: both;
	height: 350px
}

.responsive-table {
	width: 100%
}

* {
	scrollbar-width: auto;
	scrollbar-color: #f3f3f3 #fff
}

::-webkit-scrollbar {
	width: 16px
}

::-webkit-scrollbar-track {
	background: #fff
}

::-webkit-scrollbar-thumb {
	background-color: #f3f3f3;
	border-radius: 10px;
	border: 3px solid #fff
}

.table-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #32ccfe;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px;
	color: #fff;
	position: sticky;
	top: 0
}

.table-row-container {
	height: 100%;
	overflow-y: auto;
	border-radius: 5px;
	width: 100%;
	animation: animate-table-row 1s ease
}

@keyframes animate-table-row {
	from {
		margin-left: -50px
	}

	to {
		margin-left: 0
	}
}

.table-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #f3f3f3;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px
}

.table-header .col-1 {
	margin-right: 5px
}

.col-1 {
	flex-basis: 10%;
	text-align: left;
	white-space: nowrap
}

.col-2 {
	flex-basis: 10%;
	text-align: left;
	margin-left: 5px
}

.col-3 {
	flex-basis: 35%;
	text-align: left;
	margin-left: 5px
}

.col-data {
	text-align: left
}

/* .col-4 {
	flex-basis: 10%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center
} */
.shipment-status-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 8px;
    margin-top: 2px;
    margin-bottom: 2px;
}

.shipment-status-container p{
    margin-top: 0;
    margin-bottom: 0;
}

.activity-description{
    margin: 0;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #d4d4d4;
}

.col-4 {
	flex-basis: 45%;
    /* margin-left: auto; */
	display: flex;
	justify-content: flex-start;
	align-items: center;
    flex-wrap: wrap;
    word-break: break-word;
    overflow-wrap: break-word;
}

.col-4 p{
    margin-left: 2px;
    /* font-size: .6rem; */
}

.service-text {
	background-color: #d4d4d4;
	padding: 2.5px 10px;
	border-radius: 999px;
	width: fit-content;
	margin: 0;
	font-size: 12px
}

.shipmentid-text {
	margin: 0;
	color: #6a6a6a;
	width: fit-content;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.shipmentid-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    /* flex-basis: 25%; */
    min-width: 65%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.button-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	margin: 0;
	animation: animate-table-row 1s ease
}

.print-selected-text {
	margin: 0;
	margin-bottom: 5px;
	margin-right: 5px;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.download-csv {
	margin-top: 5px
}

.void-selected-text {
	margin: 0;
	margin-bottom: 5px;
	padding: 2.5px 10px;
	margin-bottom: 5px;
	border-radius: 999px;
	background-color: #fe804d;
	border: 1px solid #ff5512;
	color: #fff;
	transition-duration: .5s
}

.print-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.void-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.close-label {
	margin-left: auto
}

.label-container {
	width: 100%
}

@media only screen and (max-width:600px) {
	.service-text {
		font-size: 8px
	}

    .svg-container-outer{
        font-size: 10px;
    }
}

@media only screen and (max-width:1135px) {
	.col-1 {
		min-width: 10%
	}
}
</style>